import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Houdt het terugmeldformulier gelijk met de gekozen kleur.
 *
 * Bij een kleurwissel herlaadt Horizon de pagina niet. De variant-picker haalt
 * de nieuwe HTML op en lost een promise op; elk component werkt daarna zichzelf
 * bij. Zonder dit script bleef het formulier op de kleur staan waarmee de
 * pagina geladen was — dus stond er een verkeerde kleurnaam in de tekst én in
 * het verborgen veld dat de winkelier mailt. Dat laatste is het echte probleem:
 * een verkeerde tekst zie je, een verkeerd verborgen veld niet.
 *
 * Er wordt hier de hele inhoud gemorpht in plaats van veld voor veld bijgewerkt.
 * Dat regelt in één keer de kleurnaam, het artikelnummer, de form-id én het
 * geval waarin de nieuwe kleur wél leverbaar is en het formulier dus helemaal
 * weg moet.
 *
 * Hetzelfde patroon als product-sku.js, met morph erbij omdat dit blok meer is
 * dan één stukje tekst.
 */
class ProductTerugmeldingComponent extends Component {
  #doel = null;

  connectedCallback() {
    super.connectedCallback();
    this.#doel = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    this.#doel?.addEventListener(StandardEvents.productSelect, this.#bijKeuze);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#doel?.removeEventListener(StandardEvents.productSelect, this.#bijKeuze);
    this.#doel = null;
  }

  #bijKeuze = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        // Bij een gecombineerde aanbieding kan de wissel naar een ander product
        // gaan. Dan hoort dit blok niet te reageren op andermans event.
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const nieuw = detail.html.querySelector(
          `product-terugmelding-component[data-block-id="${CSS.escape(this.dataset.blockId ?? '')}"]`
        );
        if (!nieuw) return;

        // Wat de bezoeker al had ingetypt niet weggooien bij een kleurwissel.
        const ingevuld = this.querySelector('.terugmelding__input')?.value ?? '';

        morph(this, nieuw);

        const veld = this.querySelector('.terugmelding__input');
        if (veld && ingevuld) veld.value = ingevuld;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[product-terugmelding] event-promise afgewezen:', error);
        }
      });
  };
}

if (!customElements.get('product-terugmelding-component')) {
  customElements.define('product-terugmelding-component', ProductTerugmeldingComponent);
}
